import { __spreadArray } from '../node_modules/tslib/tslib.es6.js';
import BrandclubStoreConfigUtils from './brandclubStoreConfigUtils.js';

var Logger = /** @class */ (function () {
    function Logger(context, stage) {
        if (stage === void 0) { stage = BrandclubStoreConfigUtils.getAppStage(); }
        this.context = context;
        // Set default log level based on stage
        this.logLevel = stage === 'prod' ? Logger.LOG_LEVELS.ERROR : (stage === 'localhost' ? Logger.LOG_LEVELS.DEBUG : Logger.LOG_LEVELS.INFO);
    }
    Logger.prototype.formatMessage = function (level, message) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var timestamp = new Date().toISOString().split('T')[1].split('.')[0];
        var formattedMessage = "[".concat(level, "] [").concat(timestamp, "] [").concat(this.context, "] ").concat(message);
        var consoleMethods = {
            // eslint-disable-next-line no-console
            'DEBUG': console.debug,
            // eslint-disable-next-line no-console
            'INFO': console.info,
            // eslint-disable-next-line no-console
            'WARN': console.warn,
            // eslint-disable-next-line no-console
            'ERROR': console.error
        };
        // eslint-disable-next-line no-console
        var consoleMethod = consoleMethods[level] || console.log;
        if (args.length > 0) {
            consoleMethod.apply(void 0, __spreadArray([formattedMessage], args, false));
        }
        else {
            consoleMethod(formattedMessage);
        }
    };
    Logger.prototype.debug = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.logLevel <= Logger.LOG_LEVELS.DEBUG) {
            this.formatMessage.apply(this, __spreadArray(['DEBUG', message], args, false));
        }
    };
    Logger.prototype.info = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.logLevel <= Logger.LOG_LEVELS.INFO) {
            this.formatMessage.apply(this, __spreadArray(['INFO', message], args, false));
        }
    };
    Logger.prototype.warn = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.logLevel <= Logger.LOG_LEVELS.WARN) {
            this.formatMessage.apply(this, __spreadArray(['WARN', message], args, false));
        }
    };
    Logger.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.logLevel <= Logger.LOG_LEVELS.ERROR) {
            this.formatMessage.apply(this, __spreadArray(['ERROR', message], args, false));
        }
    };
    Logger.prototype.setLogLevel = function (level) {
        this.logLevel = Logger.LOG_LEVELS[level];
    };
    Logger.LOG_LEVELS = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        NONE: 4
    };
    return Logger;
}());

export { Logger };
//# sourceMappingURL=logger.js.map
